import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";

import { AppInterceptor } from "./interceptors/app-interceptor";
import { SecondsToMinutesPipe } from "./pipes/seconds-to-minutes.pipe";

@NgModule({
  declarations: [SecondsToMinutesPipe],
  exports: [SecondsToMinutesPipe],
  imports: [CommonModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
  ],
})
export class AppCoreModule {}
